<template>
	<a v-if="renderAddDipsElement" class="add-dips-button" @click="onAddDipsClick">
		<span>{{ $t("utilityComponents.addDips.cartAddDips") }}</span>
	</a>
</template>

<script>
import { orderLineCheckIfDipIsSelected } from "../../../domains2/orderlines/orderlineHelper";

export default {
	name: "AddDips",
	props: ["product", "orderLine"],
	computed: {
		renderAddDipsElement() {
			const self = this;
			if (self.$store.getters.featureToggles.enableAddDipsFromCart &&
				self.$props.orderLine.isMenu &&
				self.$props.product.groups.some(g => g.options.groupType === "dips") &&
				!orderLineCheckIfDipIsSelected(self.$props.orderLine)
			) {
				return true;
			}
			return false;
		}
	},
	methods: {
		onAddDipsClick() {
			const self = this;
			self.$emit("addDipsButtonClicked");
		}
	}
};
</script>

<style lang="scss" scoped>
.add-dips-button {
	span {
		font-size: 13px;
		color: #218C74 !important;
	}
}
</style>
